import { Modal, Progress, Button } from 'antd';
import { useEffect, useState, useRef } from 'react';
import io from 'socket.io-client';

const socket = io(process.env.REACT_APP_API_URL, {
    transports: ['websocket', 'polling'],  // Ensure both transports
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
    timeout: 10000,
}); // Adjust to your backend URL

function ImportComponent({ visible, onCancel }) {
    const [logs, setLogs] = useState([]);
    const [progress, setProgress] = useState(0);
    const [expanded, setExpanded] = useState(false);
    const logContainerRef = useRef(null);


    socket.on('connect', () => {
        console.log('Connected to server');
    });

    socket.on('connect_error', (error) => {
        console.error('Connection error:', error);
    });

    useEffect(() => {
        // Listen for logs
        socket.on('import-log', (log) => {
            setLogs((prevLogs) => [...prevLogs, log]);
        });

        // Listen for progress updates separately
        socket.on('import-progress', (progressValue) => {
            setProgress(progressValue);
        });

        return () => {
            socket.off('import-log');
            socket.off('import-progress');
        };
    }, []);

    useEffect(() => {
        // Scroll to the bottom when new logs are added
        if (logContainerRef.current) {
            logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
        }
    }, [logs]);

    return (
        <Modal title="Importation" visible={visible} footer={null} onCancel={onCancel}>
            <h3>importation en cours</h3>
            <Progress percent={progress} status={progress < 100 ? 'active' : 'success'} />

            <div
                style={{
                    maxHeight: expanded ? '300px' : '100px',
                    overflowY: 'auto',
                    border: '1px solid #ddd',
                    padding: '10px',
                    transition: 'max-height 0.3s ease-in-out'
                }}
                ref={logContainerRef}
            >
                <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                    {logs.map((log, index) => (
                        <li key={index}>{log}</li>
                    ))}
                </ul>
            </div>
            <Button type="link" onClick={() => setExpanded(!expanded)}>
                {expanded ? 'Voir moins' : 'Voir plus'}
            </Button>
        </Modal>
    );
}

export default ImportComponent;
